require('./RAInvestmentHorizonInput.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const RAInput = require('../../commons/RAInput/RAInput');

// @utilites
const { FormattedText } = require('core/i18n').i18n;

// @constants - robo
const {
    RA_INVESTMENT_HORIZON_INPUT_MAX,
    RA_INVESTMENT_HORIZON_INPUT_MIN,
    RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE,
} = require('../../../raConstants/index');

class RAInvestmentHorizonInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isInputFocused: false,
        };
        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.inputHandleBlur = this.inputHandleBlur.bind(this);
    }

    handleInputFocus(e) {
        if (e.target.nodeName === 'INPUT') {
            this.setState({ isInputFocused: true });
        }
    }

    inputHandleBlur() {
        this.setState({ isInputFocused: false });
    }

    mapeoInput(value) {
        // Don't mask the input if the user is changing the value by checking this.state.isInputFocused
        if (
            !this.state.isInputFocused &&
            value > RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE
        ) {
            value = RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE;
        }
        return value;
    }

    handleChangeValue(evt) {
        this.inputHandleBlur();
        this.props.updateInvestmentHorizonSlider(evt);
    }

    render() {
        const { value, disabled } = this.props;
        const inputValue = this.mapeoInput(value);
        // We need to check agains the real value and not the mapped value
        const isBiggerThanMax =
            value > RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE;
        const classNames = classnames('ra-investment-horizon-input', {
            'ra-investment-horizon-input--is-disabled': !!disabled,
        });
        const inputClassNames = classnames(
            'ra-investment-horizon-input__input',
            {
                'ra-investment-horizon-input__plus-label':
                    !this.state.isInputFocused && isBiggerThanMax,
            },
        );

        return (
            <div className={classNames}>
                <div
                    className="ra-investment-horizon-input__term-number"
                    onFocus={this.handleInputFocus}
                >
                    <RAInput
                        amount={inputValue}
                        disabled={disabled}
                        customClassName={inputClassNames}
                        onhandleChange={this.handleChangeValue} // eslint-disable-line
                        showBlurZero={true}
                        min={RA_INVESTMENT_HORIZON_INPUT_MIN}
                        max={RA_INVESTMENT_HORIZON_INPUT_MAX}
                    />
                </div>
                <div className="ra-investment-horizon-input__term-unit">
                    <FormattedText value="raInvestmentHorizonInput-raInvestmentHorizonInput_years" />
                </div>
            </div>
        );
    }
}

RAInvestmentHorizonInput.propTypes = {
    disabled: PropTypes.bool,
    updateInvestmentHorizonSlider: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
};

module.exports = RAInvestmentHorizonInput;
